// Microsoft Entra ID configuration.
//
// Every value comes from the environment. Nothing is hardcoded here, so the
// tenant and application identifiers never sit in the repository — set them in
// .env.local for development and as build-time variables in your pipeline.
//
// Note the honest limitation: Create React App inlines REACT_APP_* values at
// build time, so these end up in the published JavaScript bundle no matter
// what. That is expected for a browser app — the client ID is a public
// identifier and the security boundary is the redirect-URI allow list on the
// app registration, not the secrecy of this value. Keeping it out of source
// control still matters: it stops the tenant being discoverable from a public
// repository, and lets each environment point at its own registration.

const clientId = process.env.REACT_APP_MSAL_CLIENT_ID || "";
const authority = process.env.REACT_APP_MSAL_AUTHORITY || "";

// A syntactically valid placeholder keeps MSAL from throwing during start-up
// when the app has not been configured; the sign-in button reports the
// misconfiguration instead of failing with an opaque error.
const PLACEHOLDER_CLIENT_ID = "00000000-0000-0000-0000-000000000000";

/** True when both identifiers are present, so sign-in can actually work. */
export const isMsalConfigured = Boolean(clientId && authority);

export const msalConfig = {
  auth: {
    clientId: clientId || PLACEHOLDER_CLIENT_ID,
    authority: authority || "https://login.microsoftonline.com/common",
    // Defaults to this origin so a preview or staging host works without
    // extra configuration, provided the URI is registered in Azure.
    redirectUri:
      process.env.REACT_APP_MSAL_REDIRECT_URI ||
      (typeof window !== "undefined" ? `${window.location.origin}/support` : "/support"),
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};

// Only accounts on this domain may sign in to the portal.
export const ACCEPTED_DOMAIN =
  process.env.REACT_APP_ALLOWED_DOMAIN || "newageservices.in";
